import React, { Fragment, useState } from 'react';
import { FaEdit, FaEye, FaTrash } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { TD } from 'styled/table';
import checkPermission from 'utils/checkPermission';
import permissions from 'utils/permissionConstants';
import DeleteCasingTypes from './deleteCasingTypes';
import EditCasingTypes from './editCasingTypes';

const ViewContractTypeList = ({ casingType, index }) => {
  const [showViewModel, setShowViewModel] = useState(false);
  const [showEditModel, setShowEditModel] = useState(false);
  const [showDeleteModel, setShowDeleteModel] = useState(false);
  const currentUser = useSelector((state) => state.user.currentUser);
  return (
    <Fragment>
      <tr
        key={casingType._id}
        className={`${index % 2 !== 0 && 'bg-gray-100'}`}
      >
        <TD>{index + 1}</TD>
        <TD>{casingType.name}</TD>
        <TD>{casingType.code}</TD>
        <TD>
          {casingType.createdAt
            ? new Date(casingType.createdAt).toLocaleDateString("en-GB").replace(/\//g, '-')
            : ''}
        </TD>
        <TD>
          {checkPermission([permissions.manage_masters], currentUser) ? (
            <div className="">
              <button
                onClick={() => setShowEditModel(true)}
                className="p-2 m-1  rounded-md bg-green-500 hover:bg-green-600 text-white"
              >
                <FaEdit />
              </button>
              <button
                onClick={() => setShowViewModel(true)}
                className="p-2 m-1 rounded-md bg-yellow-500 hover:bg-yellow-600 text-white"
              >
                <FaEye />
              </button>
              {/* A casing type is marked `blocked` as soon as it has been used
                  on a validated tyre, so deleting it would orphan that record.
                  The button previously looked like any other disabled-grey
                  control, which read as "delete does nothing" - spell it out. */}
              <button
                disabled={casingType.blocked}
                title={
                  casingType.blocked
                    ? "This casing type is already used on validated tyres and cannot be deleted"
                    : "Delete"
                }
                onClick={() => setShowDeleteModel(true)}
                className={`p-2  m-1 rounded-md text-white ${
                  casingType.blocked
                    ? "bg-gray-300 opacity-70 cursor-not-allowed"
                    : "bg-red-500 hover:bg-red-600"
                }`}
              >
                <FaTrash />
              </button>
            </div>
          ) : (
            <p>----</p>
          )}
        </TD>
      </tr>
      {showViewModel && (
        <EditCasingTypes
          data={casingType}
          desable={true}
          handleClick={() => setShowViewModel(false)}
        />
      )}
      {showEditModel && (
        <EditCasingTypes
          data={casingType}
          handleClick={() => setShowEditModel(false)}
        />
      )}

      {showDeleteModel && (
        <DeleteCasingTypes
          id={casingType._id}
          handleClick={() => setShowDeleteModel(false)}
        />
      )}
    </Fragment>
  );
};

export default ViewContractTypeList;
